module.exports = __webpack_public_path__ + "static/media/work-img5.d4fd0576.jpg";